// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"41b7a711","455":"e0fd7c98","977":"eaded147"}[chunkId] + ".chunk.js";
};